/* eslint-disable react-hooks/exhaustive-deps */
import { ErrorMessage, Field } from 'formik';
import { Col, Form, FormControl, Row, Stack } from 'react-bootstrap';
import Editor from '../../../../../components/editor/Editor';
import { FormLabel, FormStepHeader } from '../../../../../components/forms';
import { FormSelect } from '../../../../../components/tables/filterForms/FormSelect';
import { useGetJokeCategoriesQuery } from '../../../../../services/endpoints/content/jokeCategory';
import { StepProps } from './AddEditJoke';

export const JokeForm = ({ touched, errors, readOnly }: StepProps) => {
  const { data, error } = useGetJokeCategoriesQuery({
    scope: 'all',
    data: { entries: 10000, orderBy: { field: 'name', order: 'asc' } }
  });

  return (
    <>
      <Row>
        <Col xs={12}>
          <FormStepHeader title="Joke Details" showRequiredLegend={!readOnly} />
          <Stack gap={3}>
            <Form.Group
              className="mb-lg-3 mb-1"
              controlId="name"
            >
              <FormLabel required>Name</FormLabel>
              <Field
                name="name"
                type="text"
                as={Form.Control}
                isInvalid={touched.name && !!errors.name}
                aria-required
              />
              <ErrorMessage name="name">
                {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
              </ErrorMessage>
            </Form.Group>
            <Form.Group controlId="joke_category_id">
              <Field
                as={FormSelect}
                name="joke_category_id"
                label="Joke Category"
                required
                disabled={readOnly}
                options={
                  data?.results?.map((jokeCategory) => ({
                    value: jokeCategory.id,
                    label: jokeCategory.name
                  })) ?? []
                }
                loadingError={error ? 'Error loading joke categories' : undefined}
              />
              <ErrorMessage name="joke_category_id.value">
                {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
              </ErrorMessage>
            </Form.Group>
            <Form.Group controlId="content">
              <FormLabel required>Content</FormLabel>
              <Field
                name="content"
                component={Editor}
                isInvalid={touched.content && !!errors.content}
                disabled={readOnly}
                aria-required
              />
              <ErrorMessage name="content">
                {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
              </ErrorMessage>
            </Form.Group>
          </Stack>
        </Col>
      </Row>
    </>
  );
};
